import React, {
  memo,
  useMemo,
  useState,
  useCallback,
  useRef,
  useEffect,
} from 'react';

import { Button } from '@material-ui/core';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { Table, Modal } from '~/components';
import { t, canURL } from '~/helpers';

import { FormRevenues } from '..';

import * as S from './styles';

function Revenues({ data, components, onCallback, ehCarregamento }) {
  const [items, setItems] = useState(data);
  const [active, setActive] = useState([]);

  const modalRef = useRef(null);

  const CRUD = useMemo(
    () =>
      Object.keys(canURL()).some((url) => ['create', 'update'].includes(url)),
    []
  );

  const cells = useMemo(
    () => [
      {
        id: 'idpresetreceita',
        label: t('s.cadastro.presetreceita.idpresetreceita'),
      },
      { id: 'nomeabreviadoproduto', label: t('s.menu.configuracao.produto') },
      {
        id: 'nomepresetreceita',
        label: t('s.cadastro.presetreceita.nomepresetreceita'),
      },
    ],
    []
  );

  // Modify currently active item
  const handleChangeModifyActive = useCallback((value) => {
    setActive(value);
  }, []);

  // Remove active item
  const handleRemoveActive = useCallback(() => {
    setItems((state) => state.filter((item) => item.id !== active[0].id));
    setActive([]);
  }, [active]);

  // Update or create record in table
  const handleUpdateOrCreateInRow = useCallback(
    (value) => {
      const values = [...items];
      const index = values.findIndex((item) => item.id === value.id);

      if (index >= 0) values[index] = value;
      else values.push(value);

      setItems(values);
      setActive([]);
    },
    [items]
  );

  useEffect(() => {
    onCallback(items);
  }, [items]);

  return (
    <S.Wrapper>
      {CRUD && (
        <header>
          <Button
            variant="contained"
            color="primary"
            size="small"
            type="button"
            onClick={() =>
              modalRef.current.handleOpenModal({ components, ehCarregamento })
            }
            disabled={isEmpty(components)}
          >
            {t('s.geral.botaoincluir')}
          </Button>

          <Button
            variant="contained"
            color="secondary"
            size="small"
            type="button"
            disabled={isEmpty(active) || isEmpty(components)}
            onClick={handleRemoveActive}
          >
            {t('s.geral.botaoexcluir')}
          </Button>
        </header>
      )}

      <Table
        noButton
        showPagination={false}
        paginate={99}
        cells={cells}
        data={items}
        onCallback={handleChangeModifyActive}
        unique="id"
        size="small"
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        title={t('s.cadastro.presetreceita.idpresetreceita')}
        maxWidth="xs"
        ref={modalRef}
        onForm={handleUpdateOrCreateInRow}
        component={FormRevenues}
        // ehCarregamento={ehCarregamento}
      />
    </S.Wrapper>
  );
}

Revenues.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  components: PropTypes.arrayOf(PropTypes.any).isRequired,
  onCallback: PropTypes.func.isRequired,
  ehCarregamento: PropTypes.bool.isRequired,
};

export default memo(Revenues);
